import {Injectable} from '@angular/core';
import {UserDetailModel} from '../dto/user-detail.model';
import {ActivatedRoute, Router} from '@angular/router';


const TOKEN_KEY = 'AuthToken';
const REFRESH_TOKEN = 'AuthToken';
const AUTH_TOKEN = 'AuthToken';
const USER_KEY = 'UserToken';

@Injectable()
export class TokenStorageService {

  private loggedUser: string;

  constructor( private router: Router,
               private route: ActivatedRoute,) {
  }

  signOut() {
    this.router.navigate([``]);
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.clear();
  }

  public saveToken(token: string) {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string {
    return sessionStorage.getItem(TOKEN_KEY);
  }

  public saveUserObjectToken(token: UserDetailModel): void {
    window.sessionStorage.removeItem(USER_KEY);
    window.sessionStorage.setItem(USER_KEY, JSON.stringify(token));
  }

  public getUserObjectToken(): UserDetailModel {
    return JSON.parse(window.sessionStorage.getItem(USER_KEY));
  }


}
